var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn num-btn",attrs:{"id":"NUMBER_4","name":"4","data-vcode":"NUMBER_4","aria-label":"4 GHI"}},[_c('div',{staticClass:"digit"},[_vm._v("4")]),_c('div',{staticClass:"letters"},[_vm._v("GHI")])])
}]

export { render, staticRenderFns }